import {compose, map, curry, propOr, reduce, pathOr, filter, head} from 'ramda'

const setStyle = curry((key, value, el) => {
    el.style[key] = value
    return el
})

const getStyle = curry((key, el) => el.style[key])

const addClass = curry((className, el) => el && el.classList.add(className))
const removeClass = curry((className, el) => el && el.classList.remove(className))
const hasClass = curry((className, el) => el && el.classList.contains(className))
const toggleClass = curry((className, el) => hasClass(className, el) ? removeClass(className, el) : addClass(className, el))

window.aboundSchoolSubTabs = (selectedPlaceholderEl, menuEl, menuItemEls, subProgramLinks) => {
    if(!selectedPlaceholderEl || !menuEl || !menuItemEls) return
    const open = addClass('open')
    const close = removeClass('open')
    const isOpen = hasClass('open')
    const unselect = removeClass('selected')
    const select = addClass('selected')
    const isSelected = hasClass('selected')
    const unselectAll = map(unselect)
    const getContentEl = el => document.getElementById(el.dataset.contentId)
    const getAllContentEls = map(getContentEl)
    const contentEls = getAllContentEls(menuItemEls)

    const scrollTo = (el) => {
        const scrollToY = el.getBoundingClientRect().top + window.scrollY
        window.scrollTo(0, scrollToY)
    }

    const openMenu = () => {
        open(menuEl)
        setTimeout(() => document.body.addEventListener('click', closeMenu), 1) // close if the body is clicked
    }

    const closeMenu = () => {
        close(menuEl)
        document.body.removeEventListener('click', closeMenu)
    }

    const onItemClick = (e) => {
        e.stopPropagation() // if we don't do this, the menu will get a click event after we've closed the menu and it will open itself again

        // handle the menu
        unselectAll(menuItemEls)
        select(e.currentTarget)
        selectedPlaceholderEl.innerText = e.currentTarget.innerText

        closeMenu(menuEl)

        // handle the contents
        unselectAll(contentEls)
        select(getContentEl(e.currentTarget))
    }

    const onMenuClick = () => {
        isOpen(menuEl)
            ? closeMenu(menuEl)
            : openMenu(menuEl)
    }

    const onSubProgramLinkClick = (e) => {
        e.preventDefault()
        e.stopPropagation()
        const menuItemId = pathOr(null, ['dataset', 'programLinkId'], e.currentTarget)
        if(!menuItemId) return

        const menuItemEl = head(filter(x => x.id === menuItemId, menuItemEls))
        if(!menuItemEl) return

        menuItemEl.click()
        scrollTo(menuEl)
    }

    menuEl.addEventListener('click', onMenuClick)
    menuItemEls.forEach(el => el.addEventListener('click', onItemClick))
    subProgramLinks && subProgramLinks.forEach(el => el.addEventListener('click', onSubProgramLinkClick))
}

window.aboundSchoolTabs = (tabEls, moreButtonEl, moreTitlesEl) => {
    const hide = removeClass('selected')
    const show = addClass('selected')
    const isShown = hasClass('selected')
    const hideAll = map(hide)
    const getContentEl = tabEl => document.getElementById(tabEl.dataset.contentId)
    const getAllContentEls = map(getContentEl)

    const contentEls = getAllContentEls(tabEls)

    const onBodyClick = ({target}) => {
        if(target == moreTitlesEl) return
        else hideMoreMenu()
    }

    const hideMoreMenu = () => {
        hide(moreTitlesEl)
        hide(moreButtonEl)
        document.body.removeEventListener('click', onBodyClick)
    }

    const showMoreMenu = () => {
        show(moreTitlesEl)
        show(moreButtonEl)
        setTimeout(() => document.body.addEventListener('click', onBodyClick), 1) // close if the body is clicked
    }

    const tabOnClick = ({currentTarget}) => {
        // hide all
        hideAll(tabEls)
        hideAll(contentEls)

        // show selected
        show(currentTarget)
        show(getContentEl(currentTarget))

        // hide the menu if it's open
        hideMoreMenu()
    }

    const moreButtonOnClick = () => {
        isShown(moreButtonEl)
            ? hideMoreMenu()
            : showMoreMenu()
    }

    moreButtonEl && moreButtonEl.addEventListener('click', moreButtonOnClick)
    tabEls && tabEls.length && tabEls.forEach(e => e.addEventListener('click', tabOnClick))
}

window.aboundShowMore = (showMoreEl, theRestEls, animationTransitionTimeMs) => {
    theRestEls = theRestEls.length === undefined ? [theRestEls] : theRestEls

    const grow = () => {
        showMoreEl.removeEventListener('click', grow)
        showMoreEl.remove()

        map(setStyle('maxHeight', '500px'), theRestEls)

        setTimeout(() => {
            map(setStyle('maxHeight', 'none'), theRestEls)
        }, animationTransitionTimeMs)
    }

    showMoreEl.addEventListener('click', grow)
}

window.aboundStoreHeight = (el, cssVar) => {
    const storeHeight = () => document.documentElement.style.setProperty(cssVar, window.getComputedStyle(el).height)
    window.addEventListener('resize', storeHeight)
    storeHeight()
}



// WEBPACK FOOTER //
// ./school-profile.js